import React from "react"

import { Container, Content } from "./styles"
import PlanBox from "./components/PlanBox"

export default function Plans({ openModal }) {
  return (
    <Container id="plans">
      <Content>
        <PlanBox
          icon="casa"
          title="SOS Casa"
          onClick={() =>
            window.open("https://soscasaitau.portosegurofaz.com.br/", "_self")
          }
        >
          <p>Sabe aquele reparo que não dá para deixar para depois?</p>
          <p>
            A gente executa imediatamente, de serviços hidráulicos a elétricos.
            É só chamar.
          </p>
        </PlanBox>
        <PlanBox
          icon="auto"
          title="SOS Auto e Moto"
          dataGtmName="solicitar servico sos auto e moto"
          onClick={() => {
            const dataLayer = window.dataLayer || []

            dataLayer.push({
              event: "abrir_modal",
              nome: "chat-porto-seguro-faz",
            })

            openModal()
          }}
        >
          <p>Seu veículo deu pane no caminho daquela reunião importante?</p>
          <p>Não tem problema, é só chamar o SOS Auto que a gente resolve!</p>
        </PlanBox>
      </Content>
    </Container>
  )
}
